<div class="calendar-container">
  <!-- Drag and Drop section -->
  <div class="drag-sample-wrapper">
    <!-- Calendar -->
    <div
      class="schedule-container"
      id="schedule-container"
      style="display: block; height: calc(100% - 33px)"
    >
      <ejs-schedule
        height="100%"
        #scheduleObj
        (created)="onCreate()"
        [enableAllDayScroll]="true"
        [showHeaderBar]="showHeaderBar"
        [currentView]="view"
        [views]="setViews"
        [eventSettings]="eventSettings"
        [rowAutoHeight]="true"
        startHour="07:00"
        endHour="22:00"
        [workHours]="{
          start: '09:00',
          end: '18:00',
        }"
        [showWeekNumber]="false"
        [firstDayOfWeek]="1"
        (popupOpen)="onPopupOpen($event)"
        (eventRendered)="onEventRendered($event)"
        [(selectedDate)]="selectedDate"
        (dataBound)="onDataBound()"
        [timezone]="timeZone"
        (drag)="onItemDrag($event)"
        (dragStart)="eventDragStart($event)"
        (dragStop)="eventDragStop($event)"
        [readonly]="readonly"
        (cellClick)="onCellClick($event)"
        (resizeStop)="resizeStop($event)"
        (actionComplete)="onActionComplete($event)"
      >
        <e-views>
          <e-view option="Day">
            <ng-template #eventTemplate let-data>
              <app-calendar-day-view [event]="data"></app-calendar-day-view>
            </ng-template>
          </e-view>
          <e-view option="Week">
            <ng-template #eventTemplate let-data>
              <app-calendar-week-view [event]="data"></app-calendar-week-view>
            </ng-template>
          </e-view>
          <e-view option="Month">
            <ng-template #eventTemplate let-data>
              <app-calendar-month-view [event]="data"></app-calendar-month-view>
            </ng-template>
          </e-view>
        </e-views>

        <!-- Content Template -->
        <ng-template #quickInfoTemplatesContent let-data>
          <div
            class="e-event-content"
            cdkDrag
            cdkDragRootElement=".e-quick-popup-wrapper"
            [cdkDragFreeDragPosition]="dragPosition"
          >
            <app-event-info [event]="data"></app-event-info>
          </div>
        </ng-template>
      </ejs-schedule>

      <app-calendar-legend
        *ngIf="allowLegend"
        (selectionChange)="legendFilterChanged($event)"
      ></app-calendar-legend>
    </div>

    <!-- Task List view -->
    <div
      *ngIf="showWaitingTasks"
      class="treeview-container"
      [ngClass]="{ collapsed: waitingTasks.hidden }"
    >
      <div class="header">
        <!-- Title -->
        <div>
          <input
            nz-input
            placeholder="Search"
            nzSize="small"
            (ngModelChange)="searchTask($event)"
            [(ngModel)]="searchTaskValue"
            *ngIf="waitingTasks.search && !waitingTasks.hidden"
          />
          <div *ngIf="!waitingTasks.search || waitingTasks.hidden">
            <div *ngIf="loadingTasks">
              <nz-icon nzType="loading" nzTheme="outline" /> Loading tasks...
            </div>
            <div *ngIf="!loadingTasks" style="display: inline-flex">
              Waiting tasks

              <app-due-date-comparsion-tags
                *ngIf="!waitingTasks.hidden"
                style="
                  display: block;
                  height: 16px;
                  margin-left: 6px;
                  margin-top: -2px;
                "
                [overdue]="waitingTasksInsights.overdue"
                [today]="waitingTasksInsights.duetoday"
                [total]="waitingTasks.data?.dataSource?.length"
                (selected)="selectedDueDate($event)"
                [clickable]="true"
              ></app-due-date-comparsion-tags>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="inline-flex gap-1">
          <button
            nz-button
            nzSize="small"
            nz-dropdown
            [nzDropdownMenu]="menu"
            *ngIf="!waitingTasks.search && !waitingTasks.hidden"
          >
            <nz-icon nzType="filter" nzTheme="outline" />
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-submenu nzTitle="Sort by name">
                <ul>
                  <li nz-menu-item (click)="sortTasksBy('billing_name', 'asc')">
                    A-Z
                  </li>
                  <li
                    nz-menu-item
                    (click)="sortTasksBy('billing_name', 'desc')"
                  >
                    Z-A
                  </li>
                </ul>
              </li>
              <li nz-submenu nzTitle="Sort by due date">
                <ul>
                  <li nz-menu-item (click)="sortTasksBy('date_diff', 'asc')">
                    Newest
                  </li>
                  <li nz-menu-item (click)="sortTasksBy('date_diff', 'desc')">
                    Oldest
                  </li>
                </ul>
              </li>
              <li nz-submenu nzTitle="Sort by post code">
                <ul>
                  <li nz-menu-item (click)="sortTasksBy('postcode', 'asc')">
                    A-Z
                  </li>
                  <li nz-menu-item (click)="sortTasksBy('postcode', 'desc')">
                    Z-A
                  </li>
                </ul>
              </li>
            </ul>
          </nz-dropdown-menu>
          <button
            nz-button
            nzSize="small"
            [nzType]="waitingTasks.search ? 'primary' : 'default'"
            (click)="
              waitingTasks.search = !waitingTasks.search;
              searchTask('');
              searchTaskValue = ''
            "
            *ngIf="!waitingTasks.hidden"
          >
            <nz-icon nzType="search" nzTheme="outline" />
          </button>
          <button
            nz-button
            nzSize="small"
            [nzType]="waitingTasks.hidden ? 'primary' : 'default'"
            (click)="waitingTasks.toggle()"
            [nzTooltipTitle]="waitingTasks.hidden ? 'Show' : 'Hide'"
            nzTooltipPlacement="bottom"
            nz-tooltip
          >
            <nz-icon
              nzType="right"
              nzTheme="outline"
              *ngIf="!waitingTasks.hidden"
            />
            <nz-icon
              nzType="left"
              nzTheme="outline"
              *ngIf="waitingTasks.hidden"
            />
          </button>
        </div>
      </div>

      <div class="body" [hidden]="waitingTasks.hidden">
        <nz-empty
          *ngIf="!loadingTasks && !waitingTasks.data?.dataSource?.length"
          nzNotFoundImage="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
          [nzNotFoundContent]="'No waiting tasks found'"
          style="
            display: inline-flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 314px;
            height: 100%;
          "
        ></nz-empty>

        <ejs-treeview
          #treeObj
          [fields]="waitingTasks.data"
          cssClass="treeview"
          dragArea=".drag-sample-wrapper"
          [allowDragAndDrop]="true"
          (nodeDragStop)="onTreeDragStop($event)"
          (nodeDragging)="onItemDrag($event)"
          [hidden]="loadingTasks || !waitingTasks.data?.dataSource?.length"
          (created)="fetchWaitingTasks()"
        >
          <ng-template #nodeTemplate let-data>
            <div class="node">
              <div
                style="
                  display: inline-flex;
                  width: 100%;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  align-items: center;
                "
              >
                <div>
                  <app-module-tag
                    [clickable]="false"
                    [module]="data.type"
                  ></app-module-tag>
                </div>

                <button
                  nz-button
                  [nzSize]="'small'"
                  (click)="openExternalLink(data.externalLink)"
                  [attr.middle-click]="data.externalLink"
                  nzTooltipTitle="Redirect"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <nz-icon nzType="link" nzTheme="outline" />
                </button>
              </div>
              <h3>
                {{ data.billing_name }}
              </h3>
              <a
                class="address"
                href="https://maps.google.com/?q={{
                  utilities.formatAddress(data)
                }}"
                target="_blank"
              >
                {{ utilities.formatAddress(data) }}
              </a>
              <p *ngIf="data.description">{{ data.description }}</p>
              <p *ngIf="data.status" style="margin-top: 2px">
                Project status: {{ data.status }}
              </p>
              <app-due-date-tag
                [due_date]="data.due_date"
                style="display: block; margin-top: 4px"
              ></app-due-date-tag>
            </div>
          </ng-template>
        </ejs-treeview>
      </div>
    </div>
  </div>
</div>
